import React from 'react';
export const RightArrowIcon = () => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.327 4.827a.833.833 0 0 0 0 1.179l3.16 3.16H5.5a.833.833 0 0 0 0 1.667h7.989l-3.161 3.161a.832.832 0 1 0 1.179 1.178l4.582-4.583a.831.831 0 0 0 .245-.566v-.047a.83.83 0 0 0-.244-.565l-4.583-4.584a.833.833 0 0 0-1.18 0Z",
    clipRule: "evenodd"
  }));
};